module.exports = __webpack_public_path__ + "static/media/refresh.64d44825.svg";